import * as React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import { connect } from "react-redux";
import Local from "../../../redux/actions/local";
import CustomerUsers from "../../../redux/actions/thunks/CustomerUsers";
import { Checkbox, List, ListItem } from "@material-ui/core";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      marginLeft: "24%",
    },
  },
};
function getStyles(item, selected, Theme) {
  const index = selected.findIndex((sel) => sel.id == item.id);
  return {
    fontWeight:
      index === -1
        ? Theme.typography.fontWeightRegular
        : Theme.typography.fontWeightMedium,
  };
}
const useStyles = makeStyles((theme) => ({
  formControl: {},
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  submit: { margin: theme.spacing(3, 0, 2) },
}));

const AddUserAuthorities = ({
  allAuthorities,
  selectedAuthorities,

  selectedUser,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const [selected, setSelected] = React.useState(
    selectedUser?.userAuthorities || []
  );
  console.log("selected", selected);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    const index = selected.findIndex(
      (item) => item.id == value[value.length - 1]
    );
    if (index == -1) {
      const selectedObjects = [...allAuthorities].findIndex(
        (authr) => authr.id === value[value.length - 1]
      );
      setSelected([...selected, allAuthorities[selectedObjects]]);
    } else {
      setSelected(selected.filter((item) => item.id != selected[index].id));
    }
  };
  React.useEffect(() => {
    selectedAuthorities(selected);
  }, [selected.length]);

  return (
    <div>
      <List style={{ display: "flex" }}>
        {allAuthorities.map((item, index) => (
          <ListItem key={index}>
            <Checkbox
              checked={selected?.findIndex((i) => i.id === item.id)>=0}
              onChange={(event) => {
                const findIndex = selected?.findIndex((i) => i.id === item.id);
                if (findIndex >= 0 && !event.target.checked) {
                  setSelected(selected.filter((i) => i.id !== item.id));
                } else if(event.target.checked) {
                  setSelected([...selected, item]);
                }

                console.log(index);
              }}
            />
            <Chip label={item.name} />
          </ListItem>
        ))}
      </List>
      {/* <FormControl fullWidth className={classes.formControl}>
        <InputLabel id="demo-mutiple-chip-label">Authorities</InputLabel>
        <Select
          labelId="demo-mutiple-chip-label"
          id="demo-mutiple-chip"
          displayEmpty={true}
          multiple
          value={selected}
          onChange={handleChange}
          input={<Input id="select-multiple-chip" />}
          MenuProps={MenuProps}
          renderValue={(renderItem) =>
            selected.map((item) => {
              const findedIndex = allAuthorities.findIndex(
                (authority) => authority.id === item.id
              );
              return findedIndex > -1 ? (
                <Chip
                  key={allAuthorities[findedIndex].id}
                  label={allAuthorities[findedIndex].name}
                  className={classes.chip}
                />
              ) : null;
            })
          }
        >
          {allAuthorities.map((item) => (
            <MenuItem
              key={item.id}
              value={item.id}
              style={getStyles(item, selected, theme)}
            >
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}
    </div>
  );
};

const mapState = (state) => ({
  allAuthorities: state.customerUsers.authorizations,
  selectedUser: state.orgUsers.dialog.selectedUser,
});

const mapDispatch = {
  getAllAuthorizations: CustomerUsers.getAllAuthorizations,
};

export default connect(mapState, mapDispatch)(AddUserAuthorities);
